import ChkIcon from '../../../../../resources/common/chk.svg';
import ChkOnIcon from '../../../../../resources/common/chk_on.svg';

const style = `
  /*------로그인페이지------*/
    #login_container {
      display: flex;
      height: 100%;
      box-sizing: border-box;
      overflow:hidden;
    }
    #login_container .bg_img {
      width: 60%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      box-sizing: border-box;
      z-index: 999;
      overflow: hidden;
    }
    #login_container .bg_img_hd {
      padding: 15.5vh 50px 0 50px;
    }
    #login_container .bg_img_hd h1 {
      font-size: 3.5vw;
      font-weight: 900;
      line-height: 1.3;
      text-align: left;
      color: #111111;
      word-break: break-word;
      letter-spacing: -1px;
    }
    #login_container .login_inform {
      width: 40%;
      padding: 15.5vh 20px;
      box-sizing: border-box;
      overflow-y: auto;
    }
    #login_container .login_inform .brd_logo {
      max-width: 360px;
      max-height: 60px;
      line-height: inherit;
      margin: 0px auto 40px;
    }

    #login_container .login_inform .brd_logo img {
      width: auto;
      display: block;
      margin: 0 auto;
      max-height:60px;
      max-width:inherit;
    }
    #login_container .login_inform_wrap input {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
    }
    input:-internal-autofill-selected {
      background-color: #fff !important;
    }
    #login_container .login_inform_list {
      display: flex;
      align-items: center;
      width: 360px;
      justify-content: center;
      margin: 0 auto;
    }

    #login_container .login_inform_list .login_inform_list_div {
      width: 100%;
      text-align: left;
    }
    #login_container .login_inform_list .login_inform_list_div span {
      display: inline-block;
      font-size: 18px;
      color: #111;
      font-weight: bold;
    }
    #login_container .login_inform_list .login_inform_list_div span:after {
      content: "";
      display: block;
      width: 12px;
      height: 2px;
      background: #111;
      margin-top: 5px;
    }
    #login_container .login_inform_list li {
      width: 40%;
      height: 30px;
      line-height: 30px;
      margin-bottom: 5px;
      box-sizing: border-box;
    }

    #login_container .login_inform_list li span {
      position: relative;
      font-size: 16px;
      text-align: center;
      box-sizing: border-box;
      padding-bottom: 7px;
      font-weight: bold;
      color: #cccccc;
      display: block;
      cursor: pointer;
    }
    #login_container .login_inform_list li span:after {
      content: "";
      position: absolute;
      display: block;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 1px;
      background: #ccc;
    }
    #login_container .login_inform_list li.active span:after,
    #login_container .login_inform_list li:hover span:after {
      height: 2px;
      background: #111111;
    }
    #login_container .login_inform_list li.active span,
    #login_container .login_inform_list li:hover span {
      color: #111111;
    }
    #login_container .login_box {
      max-width: 360px;
      margin: 30px auto 0;
    }
    #login_container .login_box .login_input_div {
      position: relative;
      margin-bottom: 10px;
    }
    #login_container .member_box .login_input_div:last-child {
      margin-bottom: 0;
    }
    #login_container .login_box .login_input_div img {
      position: absolute;
      top: 50%;
      right: 12px;
      transform: translateY(-50%);
    }
    #login_container .login_box input.login_input {
      width: 100%;
      font-size: 13px;
      height: 60px;
      border-radius: 4px;
      padding: 10px 50px 10px 20px;
      outline: none;
      box-sizing: border-box;
      background-color: #f7f7fa;
      border: 2px solid rgba(247, 247, 250, 1);
      color: #111;
      -webkit-text-fill-color: #111;
      color-scheme: light;
    }
    #login_container .login_box input.login_input:focus {
      border: 2px solid #6a6af8;
      background: rgba(247, 247, 250, 1);
      color: #111;
      -webkit-text-fill-color: #111;
    }
    #login_container .login_box input.login_input:-webkit-autofill,
    #login_container .login_box input.login_input:-webkit-autofill:hover,
    #login_container .login_box input.login_input:-webkit-autofill:focus,
    #login_container .login_box input.login_input:-webkit-autofill:active {
      -webkit-box-shadow: 0 0 0 30px rgba(247, 247, 250, 1) inset !important;
      -webkit-text-fill-color: #111 !important;
    }
    

    #login_container .login_box input.login_input:last-child {
      margin-bottom: 0;
    }
    #login_container .login_box input.login_input::placeholder {
      font-size: 13px;
      text-align: left;
      line-height: 1.63;
      color: #888888 !important;
    }
    #login_container .id_save {
      margin: 20px 0;
    }
    #login_container .id_save label,
    #login_container .agree_form label {
      display: flex;
      align-items: center;
      font-size: 13px;
      line-height: initial;
      text-align: left;
      color: #666666;
      word-wrap: break-word;
      word-break: keep-all;
    }
    #login_container .id_save input,
    #login_container .agree_form input {
      display: none;
    }
    #login_container .id_save input + label#chk_label span,
    #login_container .agree_form input + label#chk_label span {
      display: inline-block;
      width: 24px;
      min-width:24px;
      height: 24px;
      background: url("${ChkIcon}");
      cursor: pointer;
      margin-right: 6px;
    }
    #login_container .id_save input:checked + label#chk_label span,
    #login_container .agree_form input:checked + label#chk_label span {
      background: url("${ChkOnIcon}");
    }

    #login_container .login_enter {
      width: 100%;
      height: 48px;
      line-height: 48px;
      border-radius: 4px;
      background-color: #6a6af8;
    }
    #login_container .login_enter span {
      display: block;
      font-size: 16px;
      line-height: 48px;
      color: #ffffff;
      cursor: pointer;
      text-align: center;
    }

    #login_container .prereg_container {
      width: 360px;
      margin: 20px auto 0;
      height: 48px;
      line-height: 48px;
      border-radius: 4px;
      background-color: rgb(229, 140, 164);
      text-align:center;
    }

    #login_container .prereg_container .prereg_btn{
      display:block;
      width:100%; 
      height:100%;
      color:#000000;
      font-size:16px;
      line-height:48px;
      font-weight:bold;
      text-align:center;
      text-decoration:none;
      cursor:pointer;
    }

    #login_container .member_find ul {
      display: flex;
      align-items: center;
      justify-content: space-around;
      margin-top: 20px;
    }
    #login_container .member_find ul li {
      width: 33.33%;
    }
    #login_container .member_find ul li a {
      position: relative;
      font-size: 16px;
      display: block;
      line-height: 1.63;
      text-align: left;
      color: #666666;
      text-align: center;
    }

    #login_container .member_find ul li a:after {
      content: "";
      position: absolute;
      top: 50%;
      right: 0;
      transform: translate(-50%, -50%);
      display: inline-block;
      margin: 0 auto;
      width: 1px;
      height: 11px;
      background: #ccc;
    }
    #login_container .member_find ul li:last-child a:after {
      content: none;
    }

    #login_container .psc_box .psc_box1 > div:not(.login_error_message):not(.login_input_div):not(.agree_form):not(.login_enter) {
      text-align: left;
      margin-bottom: 20px;
    }
    #login_container .psc_box .psc_box1 .login_error_message {
      margin-bottom: 0 !important;
      margin-top: 4px !important;
    }
    #login_container .psc_hd {
      display: flex;
      justify-content: space-between;
    }
    #login_container .psc_hd p {
      position: relative;
      width: 28px;
      height: 28px;
      border-radius: 7px;
      cursor: pointer;
      background: #fff;
      box-shadow: 0 3px 3px #efefef;
    }
    #login_container .psc_hd p img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    #login_container .psd_ft {
      margin-top: 20px;
    }
    #login_container .psd_ft,
    #login_container .gst_hd {
      background: repeating-linear-gradient(
        -45deg,
        #ffeded,
        #ffeded 2px,
        #fff 0,
        #fff 5px
      );
      padding: 20px;
      box-sizing: border-box;
      font-size: 11px;
      word-break: normal;
      line-height: 1.45;
      text-align: left;
      color: #999999;
      margin-top: 20px;
    }
    #login_container .psc_box2 > p {
      font-size: 13px;
      line-height: 1.63;
      text-align: left;
      color: #666666;
      margin-bottom: 20px;
    }
    #login_container .login_box .gst_inform_message{
      text-align: left;
      margin-bottom: 18px;
    }
    #login_container .login_box .gst_inform_message span{
      font-size: 13px;
      word-break: keep-all;
      line-height: 1.69;
      color: #666;
    }
    #login_container .login_box .login_session {
      width: 100%;
      height: auto;
      padding: 20px;
      border-radius: 4px;
      text-align: left;
      background-color: #f7f7fa;
      margin-bottom: 10px;
      border: 2px solid #fff;
      box-sizing: border-box;
      transition: all 0.3s;
      cursor: pointer;
      overflow:hidden;
    }

    #login_container .login_box .login_session.active,
    #login_container .login_box .login_session:hover {
      background: #fff;
      border: 2px solid #6a6af8;
      box-sizing: border-box;
      box-shadow: 6px 6px 10px 0px rgb(106 106 248 / 20%);
    }

    #login_container .login_box .login_session .login_session_h3 {
      font-size: 15px;
      text-align: left;
      color: #333333;
      font-weight: bold;
      line-height: 1.71;
    }
    #login_container .login_box .login_session .login_session_h4 {
      width: 85%;
      overflow: hidden;
      white-space: normal;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      display: -webkit-box;
      word-break: break-all;
    }
    #login_container .login_box .login_session .login_session_h4 a{
      display: block;
      word-wrap: break-word;
      word-break: auto-phrase;
    }
    #login_container .login_box .login_session .login_session_h4 pre {
      font-family: "Noto Sans KR",sans-serif;
      font-size: 20px;
      font-weight: bold;
      line-height: 1.5;
      text-align: left;
      color: #333333;
      word-break: keep-all;
    }
    #login_container .login_box .login_session .login_session_p {
      text-align: left;
      line-height: initial;
      font-size: 12px;
      color: #666666;
      margin-top:20px;
    }
    .gst_session_hd {
      display: flex;
      justify-content: space-between;
      margin-bottom: 13px;
    }
    .gst_session_hd .morebtn {
      position: relative;
      width: 28px;
      height: 28px;
      border-radius: 7px;
      cursor: pointer;
      background: #fff;
      box-shadow: 0 3px 3px #efefef;
    }

    .gst_session_hd .morebtn img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) rotate(90deg);
      display: inline-block;
      transition: all 0.3s;
    }

    .gst_session_hd .morebtn.active img {
      transform: translate(-50%, -50%) rotate(-90deg);
      transition: all 0.3s;
    }

    .gst_session .gst_session_sub .login_input_div:first-child { margin-top: 20px; }
    .gst_session .gst_session_sub { cursor: auto; }

    .gst_session .agree_form,
    .login_box .agree_form{ margin: 20px 0 30px; }
    .gst_session .agree_form ul li,
    .login_box .agree_form ul li{ display: flex; justify-content: space-between;  margin-bottom: 20px; color: #666666; align-items: center; gap:10px; }
    .gst_session .agree_form ul li:last-child,
    .login_box .agree_form ul li:last-child{ margin-bottom: 0;}
    .gst_session .agree_form ul li a,
    .login_box .agree_form ul li a{cursor: pointer; white-space: nowrap; font-size:13px; line-height:18px; color: #666666; text-decoration: underline;}
    .gst_session .agree_form ul li p,
    .login_box .agree_form ul li p{ display: flex; align-items: center;}
    .gst_session .agree_form ul li p span,
    .login_box .agree_form ul li p span{ display: block; line-height: initial;}

    #login_container .cs_container {
      max-width: 360px;
      margin: 40px auto 30px;
      text-align: left;
      line-height: 1.5;
    }
    #login_container .cs_container h4 {
      position: relative;
      font-size: 13px;
      color: #111;
      margin-bottom: 10px;
      line-height: 1.5;
      padding-top: 10px;
      font-weight: bold;
    }
    #login_container .cs_container h4:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      display: inline-block;
      width: 10px;
      height: 2px;
      background: #111;
    }
    #login_container .cs_container p {
      color: #999999;
      font-size: 13px;
      line-height: 1.63;
    }

    #login_container .bg_img_ft {
      max-width: 360px;
      margin: 0 auto;
      font-size: 15px;
      line-height: 1.54;
      text-align: left;
      border-top: 1px solid #ccc;
      padding-top: 20px;
    }
    #login_container .bg_img_ft table{
      border: none;
      border-collapse: collapse;
      empty-cells: show;
      margin-bottom: 1em;
      margin-top: 1em;
      max-width: 100%;
    }
    #login_container .bg_img_ft table tbody tr td{
      border: 1px solid #dadada;
      min-width: 2em;
      padding: 0.4em;
      -webkit-user-select: text;
      -moz-user-select: text;
      -ms-user-select: text;
      user-select: text;
      vertical-align: middle;
    }
    #login_container .bg_img_ft .ft_info2 {
      font-size: 13px;
      margin-bottom: 10px;
      line-height: normal;
    }
    #login_container .bg_img_ft .ft_info3 {
      margin-bottom:0;
      margin-top:30px;
      text-align:right;
    }
    #login_container .bg_img_ft .ft_info3 span {
      font-size: 13px;
      line-height: normal;
      color: #999999;
      margin-bottom: 30px;
    }

    #login_container pre {
      font-family: "Noto Sans KR", sans-serif;
      font-weight: normal;
      font-size: 13px;
      line-height: 1.54;
      white-space: break-spaces;
      word-break: keep-all;
      color: #666666;
    }
    .none_event{background:#f7f7fa; padding:40px 0; text-align:center;}
    .none_event span{color:#666;}
    #login_container .campaign_list_container {
      width: 100%;
      max-width: 360px;
      box-sizing: border-box;
    }
    #login_container .campaign_list_title {
      margin: 0;
      padding: 4px 0;
      line-height: 24px;
    }
    #login_container .campaign_list {
      gap: 0;
    }
    #login_container .campaign_list_item {
      width: 100%;
      gap: 12px;
      padding: 16px 0;
      border-top: 1px solid var(--color-border-quiet);
      box-sizing: border-box;
    }
    #login_container .campaign_list_item:first-child {
      padding-top: 0;
      border-top: 0;
    }
    #login_container .campaign_list_thumb {
      flex: 0 0 64px;
      width: 64px;
      height: 64px;
      background: var(--color-surface-page);
    }
    #login_container .campaign_list_body {
      min-width: 0;
      gap: 4px;
    }
    #login_container .campaign_badge_row {
      min-height: 18px;
      flex-wrap: wrap;
    }
    #login_container .campaign_badge {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      height: 18px;
      max-width: max-content;
      padding: 0 6px;
      border: 1px solid transparent;
      border-radius: 4px;
      color: var(--color-white);
      font-size: 10px;
      font-weight: 400;
      line-height: 16px;
      cursor: default;
      box-sizing: border-box;
    }
    #login_container .campaign_badge_online {
      border-color: var(--color-badge-purple);
      background-color: var(--color-badge-purple);
    }
    #login_container .campaign_badge_offline {
      border-color: var(--color-badge-teal-soft);
      background-color: var(--color-badge-teal-soft);
    }
    #login_container .campaign_badge_onoff {
      border-color: var(--color-badge-amber);
      background-color: var(--color-badge-amber);
    }
    #login_container .campaign_list_name,
    #login_container .campaign_list_name > div,
    #login_container .campaign_list_name a {
      min-width: 0;
      max-width: 100%;
      color: inherit;
      line-height: 20px;
      overflow-wrap: anywhere;
      word-break: keep-all;
      text-decoration: none;
    }
    #login_container .campaign_list_name a:hover {
      text-decoration: underline;
    }
    #login_container .campaign_list_date {
      color: var(--color-text-muted);
      font-family: var(--font-sans);
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      overflow-wrap: anywhere;
      word-break: keep-all;
    }
    #login_container .campaign_more_button {
      padding: 2px 0;
      border-bottom: 1px solid var(--color-ink-strong);
    }
    .m_login_footer {
      display: none;
    }
    /*=================미디어 쿼리=====================*/
    @media (min-width: 768px) and (max-width: 1023px) {
      #login_container .login_inform_list,
      #login_container .login_box {
        width: 100%;
      }
    }
    
    @media (max-width: 767px) {
      body,
      html {
        min-height: auto;
      }
      #login_container {
        display: block;
        min-height: auto;
        height: auto;
      }
      #login_container .bg_img {
        display:none;
      }
      #login_container .login_inform_wrap {
        padding: 0;
      }
      .bg_img_hd {
        position: absolute;
        bottom: 20px;
        left: 20px;
        padding: 0;
      }
      .bg_img_hd img {
        width: 100%;
      }
      .bg_img_hd h1 {
        font-weight: 900;
        line-height: 1.29;
        text-align: left;
        color: #111111;
        padding-right: 20px;
      }

      #login_container .bg_img_ft {
        max-width:unset;
        width: auto;
        margin: 20px 20px;
      }

      #login_container .login_inform {
        width: 100%;
        padding: 30px 0 40px;
      }
      #login_container .login_inform .brd_logo{
        max-width:100%;
        padding:0 20px;
      }
      #login_container .login_inform_list {
        width: 100%;
        padding: 0 20px;
        box-sizing: border-box;
      }
      #login_container .login_box {
        width: 100%;
        padding: 0 20px;
        box-sizing: border-box;
        max-width:unset;
      }
      #login_container .campaign_list_container {
        max-width: 100%;
        padding: 0 20px;
      }
      #login_container .campaign_list_thumb {
        flex-basis: 56px;
        width: 56px;
        height: 56px;
      }
      #login_container .cs_container {
        max-width: 100%;
        margin: 40px 0 0;
        padding: 0 20px;
      }
      #login_container .m_login_footer {
        display: block;
        width: 100%;
        background-color: #f7f7fa;
        padding: 30px 20px;
        box-sizing: border-box;
        text-align: left;
        word-break: break-all;
      }
      #login_container .m_login_footer .ft_info {
        font-size: 15px;
        line-height: 1.71;
        margin-bottom: 0;
      }
      #login_container .m_login_footer .ft_info2 {
        font-weight: bold;
        line-height: 1.5;
        text-align: left;
        color: #333333;
        margin-bottom: 10px;
      }
      #login_container .m_login_footer .ft_info3 {margin-top:30px; margin-bottom:0;}
      #login_container .m_login_footer .ft_info3 span {color: #999999; line-height: 1.45;}
    }
    /*============로그인 페이지 css End==============*/
`
export default style
